import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@fly/core';
import { TableFilter, TableFilterOption } from '@fly/shared';
import { DropdownMenu } from '@radix-ui/themes';

export const FlyFilterDetailsDropdown = <T extends object>({
  filterOption,
  filter,
  onChange,
  onRemove,
}: {
  filterOption: TableFilterOption<T>;
  filter: TableFilter;
  onChange: (value: string) => void;
  onRemove: () => void;
}) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(!filter.value);

  const handleFilterChange = (value: string) => {
    onChange(value);
    setOpen(false);
  };

  const onOpenChange = (open: boolean) => {
    if (!open && !filter.value) {
      onRemove();
    }
    setOpen(open);
  };

  const triggerLabel =
    filterOption.getSelectedName != null
      ? t(...filterOption.getSelectedName(filter.value))
      : filterOption.name != null
        ? t(...filterOption.name)
        : (filter.value ?? filterOption.key);

  return (
    <DropdownMenu.Root open={open} onOpenChange={onOpenChange}>
      <DropdownMenu.Trigger>
        <Button
          variant='soft'
          size='1'
          className='min-w-0 max-w-full truncate'
          iconEnd={<DropdownMenu.TriggerIcon />}
          data-testid={`table-filter-trigger-${filter.key}`}
        >
          {triggerLabel}
        </Button>
      </DropdownMenu.Trigger>
      <DropdownMenu.Content className='p-0'>
        {filterOption.FilterView && (
          <filterOption.FilterView
            filter={filter}
            filterOption={filterOption}
            onChange={handleFilterChange}
            onRemove={onRemove}
          />
        )}
      </DropdownMenu.Content>
    </DropdownMenu.Root>
  );
};
